/** @jsx jsx */
import { jsx } from '@emotion/react'

import { ReactComponent as PageLoadErrorImage } from '../../images/PageLoadErrorImage.svg'
import { H1 } from '../../elements'
import { errorCss, descriptionCss } from '../errorCss'

const PageAccessError = () => (
  <div css={errorCss}>
    <PageLoadErrorImage />
    <H1>You do not have access to this page.</H1>
    <p css={descriptionCss}>Please contact your system administrator.</p>
  </div>
)

export default PageAccessError
